// extracted by mini-css-extract-plugin
export default {"row":"fZPjOAH5BrKAoUQPwk6Q","titleRow":"soXTWAbWSRq7nZyTxapa"};